import { defineMessages } from '@jutro/locale';

export default defineMessages({
    uploadDocument: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Upload Document',
        defaultMessage: 'Upload Document'
    },
    subtitle: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.subtitle',
        defaultMessage: 'Documents may take up to 2 business days to display'
    },
    continue: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Continue',
        defaultMessage: 'Continue'
    },
    cancelModal: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Cancel',
        defaultMessage: 'Cancel'
    },
    date: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Date',
        defaultMessage: 'Date'
    },
    policyNumber: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Policy Number',
        defaultMessage: 'Policy Number'
    },
    accountNumber: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Account Number',
        defaultMessage: 'Account Number'
    },
    category: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Category',
        defaultMessage: 'Category'
    },
    description: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Description',
        defaultMessage: 'Description'
    },
    fullDescription: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Full Description',
        defaultMessage: 'Full Description'
    },
    author: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Author',
        defaultMessage: 'Author'
    },
    noteDetails: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.Note Details',
        defaultMessage: 'Note Details'
    },
    closeBtnLabel: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.CLOSE',
        defaultMessage: 'CLOSE'
    },
    invalidFileSize: {
        id: 'ml.policy.MLDocumentsUploadPopup.Invalid file size. This file will not be uploaded.',
        defaultMessage: 'Invalid file size. This file will not be uploaded.'
    },
    invalidFileType: {
        id: 'ml.policy.MLDocumentsUploadPopup.Invalid file type. This file will not be uploaded.',
        defaultMessage: 'Invalid file type. This file will not be uploaded.'
    },
    documentSuccess: {
        id: 'ml.gateway.views.ActivityReports.MLDocumentUploadPopup.documentSuccess',
        defaultMessage: 'The document uploaded successfully. It may take up to 2 bussiness days for it to show on the document listing'
    },
    othersParagraph: {
        id: 'ml.policy.MLDocumentsUploadPopup.Please do not upload the Recurring Credit/Debit Card Authorization Form. This form must be mailed or faxed.',
        defaultMessage: 'Please do not upload the Recurring Credit/Debit Card Authorization Form. This form must be mailed or faxed.'
    },
    fileUploadHeader: {
        id: 'ml.policy.MLDocumentsUploadPopup.File upload',
        defaultMessage: 'File upload'
    },
    fileUploadSubHeader: {
        id: 'ml.policy.MLDocumentsUploadPopup.Documents may take up to 2 business days to display',
        defaultMessage: 'Documents may take up to 2 business days to display'
    },
    fileSeparateUpload: {
        id: 'ml.policy.MLDocumentsUploadPopup.When you have more than one document, please upload each document separately.',
        defaultMessage: 'When you have more than one document, please upload each document separately.'
    },
    whenYouHaveMoreThanOneDocument: {
        id: 'ml.policy.MLDocumentsUploadPopup.When you have more than one document, please upload each document separately',
        defaultMessage: 'When you have more than one document, please upload each document separately.'
    },
    documentUploadedSuccessfully: {
        id: 'ml.policy.MLDocumentsUploadPopup.The document uploaded successfully. It may take up to 2 business days for it to show on the document listing',
        defaultMessage: '<strong>The document uploaded successfully.</strong> It may take up to 2 business days for it to show on the document listing.'
    },
    documentUploadFail: {
        id: 'ml.policy.MLDocumentsUploadPopup.Failed to upload file',
        defaultMessage: 'Failed to upload file {fileName}'
    },
    contingencySubHeader: {
            id: 'ml.policy.MLDocumentsUploadPopup.contingencySubHeader',
        defaultMessage: 'Contingency Header'
    }
});
